import { render } from "./LogisticTableAdmin.vue?vue&type=template&id=362e5807"
import script from "./LogisticTableAdmin.vue?vue&type=script&lang=js"
export * from "./LogisticTableAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__